// Sprint 7 — Cobros reporting

import { format } from "date-fns";
import { es } from "date-fns/locale";
import type { AppointmentStatus, PaymentStatus } from "@prisma/client";
import { labelAppointmentStatus, labelPaymentStatus } from "@/lib/dashboard-labels";

export type PaymentCsvRow = {
  id: string;
  createdAt: string;
  mpPaymentId: string | null;
  paymentStatus: PaymentStatus;
  status: AppointmentStatus;
  service: { name: string; price: number | null } | null;
  court?: { name: string } | null;
  totalPaid?: number;
  balance?: number | null;
};

function csvEscape(cell: string): string {
  if (/[",\n\r]/.test(cell)) return `"${cell.replace(/"/g, '""')}"`;
  return cell;
}

/** Genera el contenido CSV (UTF-8 con BOM opcional para Excel). */
export function buildPaymentsCsvContent(rows: PaymentCsvRow[]): string {
  const headers = [
    "Servicio",
    "Estado pago",
    "Estado turno",
    "Referencia MP",
    "Fecha alta turno",
    "Importe servicio",
    "Cobrado (tabla)",
    "Saldo",
  ];
  const lines = [headers.map(csvEscape).join(",")];
  for (const r of rows) {
    const serviceName = r.service?.name ?? r.court?.name ?? "—";
    const importe = r.service?.price != null ? String(r.service.price) : "";
    const cobrado = r.totalPaid != null ? String(r.totalPaid) : "";
    const saldo = r.balance != null ? String(r.balance) : "";
    const fecha = format(new Date(r.createdAt), "yyyy-MM-dd", { locale: es });
    lines.push(
      [
        csvEscape(serviceName),
        csvEscape(labelPaymentStatus(r.paymentStatus)),
        csvEscape(labelAppointmentStatus(r.status)),
        csvEscape(r.mpPaymentId ?? ""),
        csvEscape(fecha),
        csvEscape(importe),
        csvEscape(cobrado),
        csvEscape(saldo),
      ].join(","),
    );
  }
  return "\uFEFF" + lines.join("\n");
}

/** Descarga el CSV en el navegador (efecto lateral). */
export function downloadPaymentsCsvFile(filename: string, content: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
